import { Component, EventEmitter, Input, Output } from '@angular/core'

import { BaseComponent } from 'common/helpers'
import { MediaRootDetail } from 'elements-sdk/src'

import { SubclipsClipboardService } from '../services/subclipsClipboard.service'

@Component({
  selector: 'subclips-clipboard',
  templateUrl: './subclipsClipboard.component.pug',
})
export class SubclipsClipboardComponent extends BaseComponent {
  @Input() drawerVisible = false
  @Input() root: MediaRootDetail
  @Output() open = new EventEmitter<void>()

  constructor (public subclipsClipboard: SubclipsClipboardService) {
    super()
  }

  toggle () {
    this.drawerVisible = !this.drawerVisible
    if (this.drawerVisible) {
      this.open.emit()
    }
  }
}
